import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SketchPicker from 'react-color/lib/Sketch';
import InputMask from 'react-input-mask';

class ColorPickerInput extends Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    value: '',
    onChange: () => null,
  };

  static HEX_MASK = {
    f: '[0-9A-Fa-f]',
  };

  state = {
    open: false,
  };

  onFocus = () => {
    this.setState({ open: true });
  };

  onBlur = (e) => {
    if (this.el.contains(e.relatedTarget)) return;
    this.setState({ open: false });
  };

  onInputChange = (e) => {
    const color = e.target.value;
    this.props.onChange(color);
  };

  onColorPickerChange = ({ hex }) => {
    this.props.onChange(hex);
  };

  render() {
    const { value } = this.props;
    return (
      <div
        className="c-colorpicker u-1/1"
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        ref={(el) => {
          this.el = el;
        }}
      >
        <InputMask
          className="c-colorpicker__input c-input--white"
          mask="#ffffff"
          formatChars={ColorPickerInput.HEX_MASK}
          value={value}
          onChange={this.onInputChange}
          maskChar=""
        />
        <div className="c-color c-colorpicker__color" style={{ color: value }} />
        <SketchPicker
          color={value}
          presetColors={[]}
          className="c-colorpicker__picker"
          onChangeComplete={this.onColorPickerChange}
          display-if={this.state.open}
          disableAlpha
        />
      </div>
    );
  }
}

export default ColorPickerInput;
